import BaseModel from './BaseModel'
import {action, computed, makeObservable, observable} from 'mobx'
import {isValidPhoneNumber} from 'libphonenumber-js'

export default class Person extends BaseModel {
  type = 'mother';
  constructor(store, type) {
    super(store);
    makeObservable(this, {
      type: observable,
      id: observable,
      title: observable,
      phone_number: observable,
      year_born: observable,
      forma_number: observable,
      is_valid_phone_number: computed,
      is_valid: computed,
      was_validated: observable,
      validate: action
    })
    this.type = type
  }
  
  id = 0;
  title = '';
  phone_number = '';
  year_born = null;
  forma_number = null;
  was_validated = false;
  
  get is_valid_phone_number() {
    return isValidPhoneNumber('+' + this.phone_number.replace('+', ''))
  }
  
  get is_valid() {
    let valid = true;
    if (this.title || this.phone_number){
      valid = this.title && this.is_valid_phone_number
    }
    if (this.type === 'child') {
      valid = valid && this.year_born > 0 && this.forma_number > 0
    }
    
    return valid;
  }
  
  validate = () => {
    this.was_validated = true;
  }
}